// class to generate calendar object

// Import variables
const Joi = require('joi');

// Import variables
const { joiValidateObj, identifiers } = require('../datastructComponents');
const { STATES, CALENDAR_OBJECT_OWNER_TYPES, WORKSPACE_TYPES, CHANNEL_TYPES, CALENDAR_OBJECT_TYPES } = require('@bcm/constants');
const { MapTableBase } = require('./base.class');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  ownerType: Joi.string().valid( ...Object.keys( CALENDAR_OBJECT_OWNER_TYPES ) ).required(),
  ownerId: Joi.string().required(),
  name: Joi.string().required(),
  calendarObjectType: Joi.string().valid( ...Object.keys( CALENDAR_OBJECT_TYPES ) ).required(),
  calendarObjectId: Joi.string().required(),
  start: Joi.string().required(),
  end: Joi.string().optional(),
  notificationStart: Joi.string().optional(),
  notes: Joi.string().optional(),
  isConferenceRoom: Joi.boolean().optional(),
  workspaceType: Joi.string().valid( ...Object.keys(WORKSPACE_TYPES) ).optional(),
  workspaceId: Joi.string().optional(),
  channelType: Joi.string().valid( ...Object.keys(CHANNEL_TYPES) ).optional(),
  channelId: Joi.string().optional(),
  rule: Joi.string().optional(),
};

// Define class
class CalendarObject extends MapTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super(
      identifiers.calendarObject.buildPk(obj.ownerId),
      identifiers.calendarObject.buildSk(obj.state, obj.ownerType, obj.ownerId, obj.calendarObjectType, obj.calendarObjectId),
      identifiers.calendarObject.buildGsiPk(obj.ownerId),
      identifiers.calendarObject.buildGsiSk(obj.state, obj.ownerType, obj.ownerId, obj.calendarObjectType, obj.end),
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.CalendarObject = CalendarObject;
exports.calendarObjectSchema = schema;